module.exports = __webpack_public_path__ + "img/shangjia.2352b54a.png";